export default __webpack_public_path__ + "static/media/locaweb.1f0486dd.svg";